export const fontsOswald = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Oswald-ExtraLight.ttf",
      },
    ],
    weight: "200",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Oswald-Light.ttf",
      },
    ],
    weight: "300",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Oswald-Regular.ttf",
      },
    ],
    weight: "400",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Oswald-Medium.ttf",
      },
    ],
    weight: "500",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Oswald-SemiBold.ttf",
      },
    ],
    weight: "600",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/Oswald-Bold.ttf",
      },
    ],
    weight: "700",
  },
];
